export const QuestionnaireFormValidationErrorsInfo = '<strong>UWAGA</strong>: Wysłanie formularza nie powiodło się. Należy poprawić wszystkie błędy i spróbować ponownie.';
